module.exports = __webpack_public_path__ + "static/media/no-text.43eba97d.svg";